import { CommandCode, StatusCode } from "../../utils/network/generated/protoTypes";
export var checkForJoinCoopError = function (path) { return function (action) {
    if (action.id === CommandCode.JoinCoop &&
        (action.statusCode === StatusCode.INVALID_COOP_ID ||
            action.statusCode === StatusCode.LIMIT_REACHED ||
            action.statusCode === StatusCode.INVALID_ACTION)) {
        return path;
    }
    return undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/errors/checkForJoinCoopError.ts
// module id = 1848
// module chunks = 3